module.exports = __webpack_public_path__ + "static/media/Charts.79878ea0.svg";